var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGithubinline = function SvgGithubinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 256,
    height: 108,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#github_inline_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 139,
    height: 16,
    x: 29,
    y: 6,
    fill: "#EDEFF7",
    opacity: 0.7,
    rx: 8
  }), /*#__PURE__*/React.createElement("rect", {
    width: 197,
    height: 16,
    x: 50,
    y: 22,
    fill: "#EDEFF7",
    opacity: 0.7,
    rx: 8
  }), /*#__PURE__*/React.createElement("rect", {
    width: 215,
    height: 16,
    y: 38,
    fill: "#EDEFF7",
    opacity: 0.7,
    rx: 8
  }), /*#__PURE__*/React.createElement("rect", {
    width: 187,
    height: 16,
    x: 69,
    y: 54,
    fill: "#EDEFF7",
    opacity: 0.7,
    rx: 8
  }), /*#__PURE__*/React.createElement("rect", {
    width: 186,
    height: 16,
    x: 29,
    y: 70,
    fill: "#EDEFF7",
    opacity: 0.7,
    rx: 8
  }), /*#__PURE__*/React.createElement("rect", {
    width: 119,
    height: 16,
    x: 61,
    y: 86,
    fill: "#EDEFF7",
    opacity: 0.7,
    rx: 8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#66D2E6",
    d: "M128 26c-15.47 0-28 12.72-28 28.427 0 13.36 9.029 24.447 21.211 27.573-.141-.356-.21-.854-.21-1.35v-4.834h-3.5c-1.89 0-3.642-.851-4.411-2.417-.911-1.705-1.051-4.335-3.36-5.97-.701-.57-.141-1.138.629-1.067 1.47.425 2.659 1.422 3.779 2.912 1.12 1.493 1.611 1.849 3.711 1.849.979 0 2.518-.07 3.92-.286.769-1.99 2.099-3.767 3.71-4.618-9.38-1.137-13.86-5.828-13.86-12.225 0-2.773 1.19-5.402 3.151-7.677-.629-2.204-1.471-6.752.281-8.528 4.201 0 6.72 2.773 7.349 3.482a21.263 21.263 0 0 1 6.789-1.137c2.45 0 4.69.425 6.789 1.137.629-.712 3.151-3.482 7.349-3.482 1.68 1.706.911 6.324.21 8.528 1.961 2.205 3.081 4.904 3.081 7.677 0 6.397-4.411 11.088-13.719 12.082 2.591 1.35 4.411 5.187 4.411 8.03v6.474c0 .213-.069.426-.069.639C148.16 77.382 156 66.865 156 54.427 156 38.721 143.47 26 128 26Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E0E3EA",
    fillRule: "evenodd",
    d: "M180.078 14.597a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm0 2a4 4 0 1 0 0-8 4 4 0 0 0 0 8ZM226 80a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm0 2a4 4 0 1 0 0-8 4 4 0 0 0 0 8ZM116 6a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm0 2a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm-31 98a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm0 2a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C3C8D5",
    fillRule: "evenodd",
    d: "M194 50a1 1 0 0 0-1 1v2h-2a1 1 0 0 0 0 2h2v2a1 1 0 0 0 2 0v-2h2a1 1 0 0 0 0-2h-2v-2a1 1 0 0 0-1-1ZM80 34a1 1 0 0 0-1 1v2h-2a1 1 0 1 0 0 2h2v2a1 1 0 1 0 2 0v-2h2a1 1 0 1 0 0-2h-2v-2a1 1 0 0 0-1-1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E0E3EA",
    fillRule: "evenodd",
    d: "M28 58a1 1 0 0 0-1 1v2h-2a1 1 0 1 0 0 2h2v2a1 1 0 1 0 2 0v-2h2a1 1 0 1 0 0-2h-2v-2a1 1 0 0 0-1-1Zm160 32a1 1 0 0 0-1 1v2h-2a1 1 0 0 0 0 2h2v2a1 1 0 0 0 2 0v-2h2a1 1 0 0 0 0-2h-2v-2a1 1 0 0 0-1-1Z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "github_inline_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 108,
    fill: "#fff",
    rx: 8
  })))));
};
export default SvgGithubinline;